import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiCardInfoModule } from '@components/shared/ui-card-info/ui-card-info.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { ProcessVersionsGridComponent } from './grids';
import {
    ProccessSettingsModalComponent,
    ProcessModalComponent,
    ProcessVersionsModalComponent,
} from './modals';
import { ProcessesPageComponent } from './processes.page';
import {
    ProcessIOParametersModule,
    ProcessSettingsComponent,
} from './shared';

const MODALS = [
    ProcessModalComponent,
    ProccessSettingsModalComponent,
    ProcessVersionsModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiSuggestModule,
        UiGridModule,
        UiGridResetModule,
        ProcessIOParametersModule,
        UiDateFormatModule,
        UiNgLetModule,
        UiSpinnerButtonModule,
        UiCardInfoModule,
    ],
    declarations: [
        ProcessSettingsComponent,
        ProcessesPageComponent,
        ProcessVersionsGridComponent,
        ...MODALS,
    ],
    exports: [
        ProcessesPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class ProcessModule { }
